import {
    Box,
    Button,
    FormControl,
    InputAdornment,
    Menu,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
import { formatAsMoney } from "../../src/utils/services";
  
  const AmountFilter = ({ setFilter, value, setValue, filters }) => {
    const inputElement = useRef(null);
    const [AnchorEl, setAnchorEl] = useState(null);
    const open = Boolean(AnchorEl);

    const handleChange = (event) => {
        setAnchorEl(inputElement.current.node)
    };

    const handleClose = () => {
        setAnchorEl(null)
      };

      const apply = () =>{
        handleClose()
        setFilter((prev)=>({
          ...prev,
          amount_from:value.amount_from,
          amount_to:value.amount_to,
          page:1
        }))
      }
    
  
    return (
        <>
      <FormControl>
        <Select
          autoWidth
          placeholder="Donation type"
          open={false}
          inputRef={inputElement}
          displayEmpty
          renderValue={(selected) => {
            if (!filters.amount_from && !filters.amount_to) {
              return (<Typography variant="big">Amount</Typography>);
            }
  
         return (<Typography variant="big">{`${ formatAsMoney(filters.amount_from)} - ${formatAsMoney(filters.amount_to)}`}</Typography>);;
          }}
          size="small"
          value={value || ''}
          sx={{
            borderRadius: "16px",
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                boxShadow: "none",
                border: "1px solid",
                borderColor: "grey.main",
              },
            },
          }}
          onClick={(event) => handleChange(event)}
          id="demo-simple-select"
        >
        </Select>
      </FormControl>
      <Menu
        id="lock-menu"
        anchorEl={AnchorEl}
        open={open}
        onClose={handleClose}
      >
            <Box sx={{ p: "1em" }}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ maxWidth: "7em", mr: "0.5em" }}>
              <Typography variant="big" fontWeight={500}>
                Min
              </Typography>
              <TextField
                 type={'number'}
                 value={value.amount_from}
                  onChange={(e)=>setValue((prev)=>({
                    ...prev,
                    amount_from:e.target.value
                  }))}
                size="small"
                sx={{
                  border: "none",
                  borderColor: "",
                  fontSize: "14px",
                  marginBottom: "2em",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "grey.border40",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
              />
            </Box>
            <Box sx={{ maxWidth: "7em" }}>
              <Typography variant="big" fontWeight={500}>
                Max
              </Typography>
              <TextField
                type={'number'}
                value={value.amount_to}
                size="small"
                onChange={(e)=>setValue((prev)=>({
                  ...prev,
                  amount_to:e.target.value
                }))}
                sx={{
                  border: "none",
                  borderColor: "",
                  fontSize: "14px",
                  marginBottom: "2em",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "grey.border40",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
             onClick={apply}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "none",
                mt: "1em",
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              variant="contained"
              color="primary"
              disableElevation
              disableFocusRipple
              disableRipple
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>
      </>
    );
  };
  
  export default AmountFilter;
  